<div class="container-fluid sms-gw-container" style="max-height: 90%; max-width: 800px;">
  <div class="row">
    <h3 class="w-100">
      <button class="btn btn-danger btn-sm mr-2" type="button" (click)="cancel()">Anuluj</button>
      SMS GW
    </h3>
  </div>

  <div class="row">
    <div class="col-md-8 border p-2">
      <div class="mb-2 col-md-4">
        <input [(ngModel)]="recipient" size="14" (ngModelChange)="validatePhone()" class="form-control mb-2" />
      </div>
        <div class="mb-2">
        <input [(ngModel)]="messageToSend" size="30" (keyup.enter)="sendMessage()" class="form-control mb-2" />
        <button class="btn btn-primary me-2" [disabled]="blockSend || !phoneBookNumberValid" (click)="sendMessage()">Send message</button>
        <button class="btn btn-primary" [disabled]="blockSend" (click)="refresh()">
          <i class="fa fa-sync"></i>
        </button>
      </div>

      <div *ngFor="let message of pagedMessages" class="row mb-2">
        <ng-container [ngSwitch]="message.type">
          <div *ngSwitchCase="'MTSMSMessage'" class="w-100">
            <div [ngClass]="getColorByStatus(message.status)" style="float: right">
              {{message.createDate | date:'yyyy-MM-dd HH:mm:ss'}} / {{message.statusDate | date:'yyyy-MM-dd HH:mm:ss'}}
            </div>
            <div [ngClass]="getColorByStatus(message.status)" style="float: right">{{message.status}}</div>
            <div [ngClass]="getColorByStatus(message.status)" style="float: right">{{message.sender}}</div>
            <br />
            <div class="sms-message sms-message-right">
              <pre class="sms-message-content">{{formatMessageContent(message.content)}}</pre>
            </div>
          </div>

          <div *ngSwitchCase="'MOSMSMessage'" class="w-100">
            <div class="badge badge-secondary" style="float: left">{{message.createDate | date:'yyyy-MM-dd HH:mm:ss'}}</div>
            <br />
            <div class="sms-message sms-message-left">
              <pre class="sms-message-content">{{formatMessageContent(message.content)}}</pre>
            </div>
          </div>

          <div *ngSwitchDefault>Unknown type: {{message.type}}</div>
        </ng-container>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <ngb-pagination [(page)]="page" [pageSize]="itemsPerPage" [collectionSize]="totalItems" (pageChange)="getDevicesWithFilterPage()"></ngb-pagination>
      </div>
    </div>

    <div class="col-md-4 border rounded-sm">
      <div *ngFor="let hint of hints" class="row mb-1 px-2">
        <button class="btn btn-primary" style="font-size: 11px;" type="button" (click)="setText(hint)">
          {{hint}}
        </button>
      </div>
    </div>
  </div>
</div>
